import { Box, Grid, Container, Typography } from '@material-ui/core';
import { useState } from 'react';
import Page from '../components/Page';
import { environmentCurr, baseUrl } from '../utils/constants';
import {
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppWeeklySales,
  AppWebsiteVisits
} from '../components/_dashboard/app';

export default function DashboardApp() {
  const [dataList, setDataList] = useState([]);

  return (
    <Page title="Dashboard | ZIMTA">
      <Container maxWidth="xl">
        {/* <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Hi, Welcome back</Typography>
        </Box> */}
        <Box sx={{ pb: 5 }}>
          <Typography color="#ff1744" variant="h4">
            {environmentCurr}
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWeeklySales />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppNewUsers />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppItemOrders />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppBugReports />
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <AppWebsiteVisits dataList={dataList} />
          </Grid>

          {/* <Grid item xs={12} md={6} lg={4}>
            {/* <AppCurrentVisits /> 
            <AppOrderTimeline />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline />
          </Grid> */}
          {/* 
          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks />
          </Grid> */}
        </Grid>
      </Container>
    </Page>
  );
}
